import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

// A player's name that opens their profile. Bots (no real user id) stay
// plain text. Safe inside clickable cards: the tap doesn't reach the card.
export function profilePath(id, me) {
  return id && me && id === me.id ? "/profile" : `/player/${id}`;
}

export function isPlayerId(id) {
  return typeof id === "string" && /^[0-9a-f]{24}$/i.test(id);
}

export default function PlayerLink({ id, children, className = "", testId }) {
  const navigate = useNavigate();
  const { user } = useAuth();
  if (!isPlayerId(id)) return <span className={className}>{children}</span>;
  const open = (e) => {
    e.preventDefault();
    e.stopPropagation();
    navigate(profilePath(id, user));
  };
  return (
    <span
      role="link"
      tabIndex={0}
      onClick={open}
      onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && open(e)}
      className={`cursor-pointer hover:underline underline-offset-2 ${className}`}
      data-testid={testId || `player-link-${id}`}
    >
      {children}
    </span>
  );
}
